'use strict';

// # 根据运行环境选择模块
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./store.prod');
} else {
  module.exports = require('./store.dev');
}


//////////////////
// WEBPACK FOOTER
// ./src/seed/store/index.js
// module id = 153
// module chunks = 0